import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import mapboxgl from 'mapbox-gl'
import MarkerSvg from 'react-icons/lib/md/location-on'

import MarkerPopup from './MarkerPopup'
import getImageUrl from '../utils/getImageUrl'

const markerHeight = 25
const MarkerEl = styled.div`
  cursor: ${props => (props.showPopups ? 'pointer' : 'inherit')};
  will-change: transform;
`

const MarkerIcon = styled(MarkerSvg)`
  width: ${markerHeight}px;
  height: ${markerHeight}px;
`

class Marker extends Component {
  static defaultProps = {
    center: [],
    infoVisible: false,
    infoLink: true
  }
  constructor (props) {
    super(props)
    this.state = {
      center: [
        this.props.location.fields.coordinates.lon,
        this.props.location.fields.coordinates.lat
      ],
      infoVisible: props.infoVisible || false
    }
    this.marker = null
    this.markerElement = null
  }

  shouldComponentUpdate (nextProps, nextState) {
    if (nextProps.showPopups !== this.props.infoVisible) return true
    return false
  }

  componentDidMount () {
    this.marker = new mapboxgl.Marker(this.markerElement)
    this.markerElement.style.top = `${-markerHeight / 2}px`
    this.marker.setLngLat(this.state.center).addTo(this.props.map)
  }

  componentWillUnmount () {
    this.marker.remove()
  }

  handleClick = e => {
    if (!this.props.showPopups) return false
    this.props.handleClick(e, this)
  }

  handleMouseOver = e => {
    if (!this.props.showPopups) return false
    this.props.handleMouseOver(e, this)
  }

  render () {
    return (
      <MarkerEl
        title={this.props.location.fields.title}
        onClick={this.handleClick}
        onMouseOver={this.handleMouseOver}
        innerRef={div => {
          this.markerElement = div
        }}
        infoVisible={this.state.infoVisible}
        showPopups={this.props.showPopups}
      >
        <MarkerIcon />
        {this.props.showPopups && (
          <MarkerPopup
            title={this.props.location.fields.title}
            map={this.props.map}
            center={this.state.center}
            markerHeight={markerHeight}
            infoVisible={this.state.infoVisible}
            renderAsLink={this.props.infoLink}
            image={getImageUrl(this.props.location.fields.mainImage, '800')}
            to={`/locations/${this.props.location.fields.slug}`}
          />
        )}
      </MarkerEl>
    )
  }
}

Marker.propTypes = {
  location: PropTypes.object.isRequired,
  map: PropTypes.any,
  handleClick: PropTypes.func,
  handleMouseOver: PropTypes.func,
  showPopups: PropTypes.bool
}

export default Marker



// WEBPACK FOOTER //
// ./src/components/Marker.js